import { useWindowDimensions } from 'react-native'

export const breakpoints = {
	mobile: 0,
	tablet: 768,
	desktop: 1024,
} as const

export type Breakpoint = keyof typeof breakpoints
export type ResponsiveValue<T> = {
	mobile: T
	tablet?: T
	desktop?: T
}

export function useBreakpoints() {
	const { width } = useWindowDimensions()

	const getResponsiveValue = <T>(values: ResponsiveValue<T>): T => {
		if (width >= breakpoints.desktop && values.desktop !== undefined) {
			return values.desktop
		}
		if (width >= breakpoints.tablet && values.tablet !== undefined) {
			return values.tablet
		}
		return values.mobile
	}

	return {
		// Current breakpoint
		isMobile: width < breakpoints.tablet,
		isTablet: width >= breakpoints.tablet && width < breakpoints.desktop,
		isDesktop: width >= breakpoints.desktop,

		// Utility functions
		smallerThan: (breakpoint: Breakpoint) => width < breakpoints[breakpoint],
		largerThan: (breakpoint: Breakpoint) => width >= breakpoints[breakpoint],
		between: (min: Breakpoint, max: Breakpoint) =>
			width >= breakpoints[min] && width < breakpoints[max],

		// Responsive value helper
		value: getResponsiveValue,

		// Raw values
		width,
		breakpoints,
	}
}
